import { Cart } from '../models/cart';
import { CustomerRestaurant } from '../models/customers/customerRestaurant';
import { Order } from '../models/orders/order';

export const updateCustomerRestaurant = (
  id: string,
  name?: string | null,
  cart?: Cart | null
) => {
  const restaurants = getAllCustomerRestaurants();
  let restaurant = restaurants[id] ?? {};

  restaurant = {
    ...restaurant,
    id,
    name: name || restaurant.name,
    cart: cart || restaurant.cart,
  };
  restaurants[id] = restaurant;
  localStorage.setItem('restaurants', JSON.stringify(restaurants));
  setCurrentCustomerRestaurant(restaurant);
};

export const updateCustomerOrder = (order: Order) => {
  const ordersJSON = localStorage.getItem('orders');
  const orders = JSON.parse(ordersJSON ?? '[]');
  const orderIndex = orders.findIndex((o: Order) => o.id === order.id);
  if (orderIndex !== -1) {
    orders[orderIndex] = order;
  } else {
    orders.push(order);
  }
  localStorage.setItem('orders', JSON.stringify(orders));
};

export const getAllCustomerRestaurants = () => {
  const restaurantsJSON = localStorage.getItem('restaurants');
  let restaurants: { [key: string]: CustomerRestaurant } = {};
  if (restaurantsJSON != null) {
    restaurants = JSON.parse(restaurantsJSON);
  }
  return restaurants;
};

export const setCurrentCustomerRestaurant = (
  restaurant: CustomerRestaurant
) => {
  localStorage.setItem('customerRestaurant', JSON.stringify(restaurant));
};

export const getCurrentCustomerRestaurant = () => {
  const restaurant = localStorage.getItem('customerRestaurant');
  if (!restaurant) return null;
  return JSON.parse(restaurant);
};

export const getCustomerRestaurant = (id: string) => {
  const restaurants = getAllCustomerRestaurants();
  return restaurants[id];
};
